import { toMutableList20rdgwi7d3cwi as toMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function copiedInterceptors($this) {
  return toMutableList($this.v4q_1);
}
function copyInterceptors($this) {
  $this.v4q_1 = copiedInterceptors($this);
  $this.w4q_1 = false;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.x4q_1 = ArrayList().u2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var PhaseContentClass;
function PhaseContent() {
  if (PhaseContentClass === VOID) {
    class $ {
      static y4q(phase, relation, interceptors) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.t4q_1 = phase;
        $this.u4q_1 = relation;
        $this.v4q_1 = interceptors;
        $this.w4q_1 = true;
        return $this;
      }
      static z4q(phase, relation) {
        Companion_getInstance();
        var tmp = Companion_getInstance().x4q_1;
        var $this = this.y4q(phase, relation, isInterface(tmp, KtMutableList()) ? tmp : THROW_CCE());
        // Inline function 'kotlin.check' call
        if (!Companion_getInstance().x4q_1.s1()) {
          var message = 'The shared empty array list has been modified';
          throw IllegalStateException().o(toString(message));
        }
        return $this;
      }
      a4r() {
        return this.v4q_1.s1();
      }
      v2() {
        return this.v4q_1.v2();
      }
      b4r(interceptor) {
        if (this.w4q_1) {
          copyInterceptors(this);
        }
        this.v4q_1.n2(interceptor);
      }
      c4r(destination) {
        var interceptors = this.v4q_1;
        if (destination instanceof ArrayList()) {
          destination.m8(destination.v2() + interceptors.v2() | 0);
        }
        var inductionVariable = 0;
        var last = interceptors.v2();
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination.n2(interceptors.w2(index));
          }
           while (inductionVariable < last);
      }
      d4r() {
        this.w4q_1 = true;
        return this.v4q_1;
      }
      toString() {
        return 'Phase `' + this.t4q_1.e4r_1 + '`, ' + this.v2() + ' handlers';
      }
    }
    initMetadataForClass($, 'PhaseContent');
    PhaseContentClass = $;
  }
  return PhaseContentClass;
}
//region block: exports
export {
  PhaseContent as PhaseContent20yhla4zqpd2q,
};
//endregion

//# sourceMappingURL=PhaseContent.mjs.map
